import { useContext, useState } from "react";
import UiContext from "../../../../store/ui-context";
import useAPIRequest from "../../../../custom_hooks/simple/useAPIRequest";
import { endOfMonth, format, startOfMonth } from "date-fns";

const defaultTake = 10;

export const useAPIGetCustomerDetail = () => {
  const uiContext = useContext(UiContext);
  const { requestGetOne, requestGet, loading } = useAPIRequest();
  const [data, setData] = useState(null);
  const [error, setError] = useState({});
  const [customerCode, setCustomerCode] = useState("");
  const formatDateTime = (date) => format(date, "yyyy-MM-dd HH:mm:ss");

  const [filterValue, setFilterValue] = useState({
    search: "",
    dari_tanggal: formatDateTime(startOfMonth(new Date())),
    sampai_tanggal: formatDateTime(endOfMonth(new Date())),
  });

  const sumAll = (items, field) => {
    if (!items || items.length === 0) return 0;
    return items.reduce((sum, item) => sum + (item[field] || 0), 0);
  };

  const fetchData = async ({ code }) => {
    if (!validate()) {
      return;
    }
    const newFilter = getFilter(filterValue);
    const finalFilter = `${newFilter};customer_code:=:${code ?? customerCode}`;

    return requestGet({
      fullUrl: `/api/report`,
      params: {
        prefix: "customer_detail",
        page: 1,
        take: 10000000,
        filter: finalFilter,
      },
      onError: ({ message, data }) => {
        uiContext.showErrorMsg("Error", message);
      },
      onSuccess: ({ data: _data, message, pagination }) => {
        setData({
          ..._data,
          grand_total_purchase: sumAll(_data.items, "grand_total"),
        });
      },
    });
  };

  const getFilter = (_filterValue) => {
    const filterArr = [];
    const newFilterValue = _filterValue ?? filterValue;
    if (newFilterValue.dari_tanggal) {
      filterArr.push(
        `transaction_date:>=:${
          newFilterValue.dari_tanggal.split(" ")[0]
        } 00:00:00`
      );
    }

    if (newFilterValue.sampai_tanggal) {
      filterArr.push(
        `transaction_date:<=:${
          newFilterValue.sampai_tanggal.split(" ")[0]
        } 23:59:59`
      );
    }

    return filterArr.join(";");
  };

  const validate = () => {
    let isValid = true;

    const start = new Date(filterValue.dari_tanggal);
    const end = new Date(filterValue.sampai_tanggal);
    setError({});
    if (!filterValue.dari_tanggal) {
      isValid = false;
    }

    if (!filterValue.sampai_tanggal) {
      isValid = false;
    }

    if (start > end) {
      isValid = false;
      uiContext.showErrorMsg("Error", "Start Date must be before End Date");
      setError((prev) => ({
        ...prev,
        tanggal: "Start Date must be before End Date",
      }));
    }
    return isValid;
  };

  return {
    data,
    setData,
    error,
    setError,
    filterValue,
    setFilterValue,
    fetchData,
    loading,
    customerCode,
    setCustomerCode,
  };
};
